import { trackEvent } from '../../utils/analytics';
import { withUtm } from '../../utils/utm';
import './PinnedArticles.css';

// Articles an editor pinned to a seat in the dashboard, delivered on each
// seatinfo row as `pins` ([{title, picurl, url}], max 3). Shared by the homepage
// 焦点选区 cards and the expanded rows on the seat list so the outbound tagging
// and GA4 event stay in one place.
//
// `className` styles the container per context; `seat` / `location` are the GA4
// dimensions and `utmSource` tags the outbound link so each placement is
// attributable on orientaldaily.com.my. stopPropagation matters because both
// hosts nest these links inside a clickable parent.
const PinnedArticles = ({ pins, className = '', seat, location, utmSource }) => {
  const items = Array.isArray(pins) ? pins : [];
  if (items.length === 0) return null;

  return (
    <div className={`pinned-articles ${className}`.trim()}>
      {items.map((p, i) => (
        <a
          key={p.url || i}
          className="pinned-articles__item"
          href={withUtm(p.url, utmSource)}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => {
            e.stopPropagation();
            // The untagged URL keeps these rows groupable with the same article
            // clicked from anywhere else on the site.
            trackEvent('article_clickss', { url: p.url, title: p.title, seat, location });
          }}
        >
          {p.picurl && (
            <img
              className="pinned-articles__thumb"
              src={p.picurl}
              alt=""
              loading="lazy"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          )}
          <span className="pinned-articles__title">{p.title || p.url}</span>
        </a>
      ))}
    </div>
  );
};

export default PinnedArticles;
